import { Error } from '@/mixins'

export default {
  mixins: [Error],
  data () {
    return {
      hasCheck: null,
      hasReturnAdv: null
    }
  },
  created () {
    if ('check' in this.$route.query) {
      this.hasCheck = true
    }
    if ('returnAdv' in this.$route.query) {
      this.hasReturnAdv = true
    }
  },
  computed: {
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    }
  },
  methods: {
    reload (id) {
      this.getProgram(id)
    },
    async getProgram (id) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, id)
        this.initProgram(data)
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
        this.$router.replace({ name: 'NotFound' })
      }
    },
    async createProgram (program) {
      if (program.use_tranche) {
        for (let tranche of program.tranches) {
          for (let building of tranche.buildings) {
            if (building['tranche'] === tranche.name) {
              program.buildings.push(building)
            }
          }
        }
      }
      const newProgram = this.beforeSubmit(program)
      this.submitLoading = true
      try {
        let { data } = await this.$api.post(this.$resources.PROGRAM, newProgram)
        this.$toasted.global.success(this.nameToUse + ' ajouté')
        setTimeout(() => {
          this.$router.push({ name: 'ProgramVue', params: { id: data.pk } })
        }, 1000)
        // this.$router.push({ name: 'ProgramVue', params: { id: data.pk } })
        this.submitLoading = false
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.submitLoading = false
      }
    },
    async updateProgram (program, silent = false) {
      if (!silent) this.loading = true
      const updatedProgram = this.beforeSubmit(program)
      try {
        let { data } = await this.$api.put(this.$resources.PROGRAM, updatedProgram.pk, updatedProgram)
        this.initProgram(data)
        this.submitLoading = false
        if (!silent) {
          this.loading = false
          this.$toasted.global.success(this.nameToUse + ' modifié')
          if (this.hasCheck || this.hasReturnAdv) {
            this.$router.goBack()
          } else {
            setTimeout(() => {
              this.getProgram(this.program.pk)
              this.$router.push({ name: 'ProgramVue', params: { id: this.program.pk } })
            }, 1000)
          }
        }
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.submitLoading = false
      }
    },
    async patchProgram (patchedProgram, silent = false, cb = null) {
      if (!silent) this.submitLoading = true
      patchedProgram.force = true // force for patch if program in reservation
      try {
        let { data } = await this.$api.patch(this.$resources.PROGRAM, this.p.pk, patchedProgram)
        if (!silent) {
          this.submitLoading = false
          this.$toasted.global.success(this.nameToUse + ' modifié')
        }
        this.initProgram(data)
        if (cb && typeof cb === 'function') cb()
      } catch (e) {
        console.log(e)
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async deleteProgram (program) {
      try {
        const { value } = await this.$swal({
          title: 'Suppression ' + this.nameToUse,
          text: 'Le ' + this.nameToUse + ' ne sera plus consultable, les mandats, options, dénonciations qui lui sont liées seront automatiquement annulés. Si le ' + this.nameToUse + ' contient des ventes, la suppression du ' + this.nameToUse + ' ne sera pas possible. Dans ce cas, un archivage sera appliqué afin de conserver l’historique tout en le retirant de l’exploitation courante.',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
          }
        })
        if (value && value.dismiss) return false // Cancel delete program process
        if (value) {
          this.loading = true
          try {
            await this.$api.delete(this.$resources.PROGRAM, program.pk)
            this.loading = false
            this.$toasted.global.success(this.nameToUse + ' supprimé')
            this.$router.push({ name: 'ProgramCardList' })
            this.$emit('deleteElementInList', program.pk)
          } catch (e) {
            this.loading = false
            this.handleError(e)
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
